import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from './settings/settings.service';
import { merge, Subscription } from 'rxjs';

@Component({
  selector: 'mc-season',
  templateUrl: './season.component.html',
  styleUrls: ['./season.component.scss']
})
export class SeasonComponent implements OnInit, OnDestroy {

  private componentLifeCycleSubscription: Subscription;

  constructor(
    private readonly settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.componentLifeCycleSubscription = merge(
      this.settingsService.remoteClearCacheCommandExecutor$
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.componentLifeCycleSubscription) {
      this.componentLifeCycleSubscription.unsubscribe();
    }
  }

}
